import type { Ref } from 'react';

import type { Styles } from '@flipster/styled-system/css';

import type { InlineBasisMode, ModalBasisMode } from '../../calculator/tpsl-basis';

export type TpslBasisMode = InlineBasisMode | ModalBasisMode;

export const inlineBasisModes = ['price', 'roi', 'pnl'] as const satisfies ReadonlyArray<InlineBasisMode>;
export const modalBasisModes = ['change', 'roi', 'pnl'] as const satisfies ReadonlyArray<ModalBasisMode>;

export interface TpslBasisFieldProps {
  mode: TpslBasisMode;
  modes: ReadonlyArray<TpslBasisMode>;
  value: string;
  onValueChange: (value: string) => void;
  onModeChange: (mode: TpslBasisMode) => void;
  /** Interpolated into Price({quote}) / P&L({quote}) — never hardcode USDT */
  quoteCurrency: string;
  precision: number;
  /**
   * Inline ROI/PnL: TP = unsigned; SL = always force-negative.
   * Modal rows use `ModalPriceBasisRow` with `leg` + `side` for expected-sign policy.
   */
  leg?: 'tp' | 'sl';
  placeholder?: string;
  disabled?: boolean;
  showDescriptions?: boolean;
  css?: Styles;
  onFocus?: () => void;
  onBlur?: () => void;
  inputRef?: Ref<HTMLInputElement>;
}
